<template>
    <div :id="types.selectSchool" class="center-screen hidden justify-items-center justify-center text-black" 
        :class="{'hidden' : school.length != 0, 'h-screen bg-black' : this.type === 'modal','bg-beige' : this.type === 'embedded'}">
        <div class="modal-container top-0 left-0 bottom-0 right-0" :class="{'z-50 fixed bg-modal-background flex overflow-hidden' : this.type === 'modal', 'block' : this.type === 'embedded'}">
            <div class="modal relative px-4 py-5 lg:p-8 bg-white z-50 md:rounded-2xl max-h-modal" :class="{'top-40 m-auto lg:top-0' : this.type === 'modal', 'w-full max-w-modal my-8 mx-auto' : this.type === 'embedded'}">
                <div class="modal-header-mobile flex">
                    <span class="absolute right-8" @click="closePopup">
                        <img src="/img/icons/close.png" class="w-5">
                    </span>
                </div>
                <h2 class="font-bold text-xl lg:text-2xl mt-4 mb-5 mx-auto text-center">{{ trans[lang].title }}</h2>
                <h3 class="font-bold text-sm mx-auto max-w-xl text-center leading-5 mb-8 mt-6 xl:mt-0">{{ trans[lang].subtitle }}</h3>
                <div class="grid md:grid-cols-2">
                    <div class="col-span-1">
                        <div class="flex ml-8">
                            <span class="text-grey font-bold text-xs"> {{ trans[lang].direction }} </span>
                        </div>
                        <!-- Street Search -->
                        <div class="street-search flex">
                            <img src="/img/icons/location.svg" class="pb-2" width="14" height="26">
                            <div class="border-b-2 w-full ml-4">
                                <input name="address" :id="types.streetSearch" v-model="inputValue" type="text" class="w-85 lg:w-11/12 py-2 text-xs lg:text-base" :placeholder="[trans[lang].placeholder]" @keyup="autocompleteStreet">
                                <button class="m-auto relative ml-3 lg:ml-0" @click="clearInput">
                                    <img src="/img/icons/cancel.svg" class="w-5 h-5">
                                </button>
                            </div>
                        </div>
                        <!-- Get Current Location -->
                        <div class="get-location flex mt-4 lg:ml-8 cursor-pointer" :class="{ 'hidden' : this.location !== '' || loading }" @click="getCurrentLocation">
                            <img src="/img/icons/navigation.svg" width="26" height="27">
                            <span class="ml-4 text-watermelon font-bold text-sm"> {{ trans[lang].posActual }} </span>
                        </div>
                        <!-- Street Autocomplete -->
                        <div :id="types.streetAutocomplete" class="street-autocomplete ml-4 p-2 rounded-2xl z-50 bg-white w-lg relative mx-auto" :class="{ 'hidden' : predictions === '' }">
                            <div v-for="(prediction, key) in predictions" :key="key" class="m-2">
                                <button v-if="key < 3" @click="autocompleteInput(prediction.place_id)" class="card grid text-left py-2 px-4 my-2 w-full rounded-2xl">
                                    <span class="street font-bold text-sm">{{ prediction.structured_formatting.main_text }}</span>
                                    <span class="city text-xs">{{ prediction.structured_formatting.secondary_text }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="loading flex mt-4 ml-8" :class="{ 'hidden' : !loading }">
                            <img class="animate-spin" :src="'/img/icons/loading.svg'" :alt="loading" />
                            <span class="ml-4 text-watermelon font-medium"> {{ trans[lang].gettingLocation }} </span>
                        </div>
                        <!-- Show Schools -->
                        <div class="get-location flex mt-8 ml-8" :class="{ 'hidden' : this.location === '' || loading || predictions !== ''}">
                            <span class="text-grey font-bold text-xs"> {{ trans[lang].near }} </span>
                        </div>
                        <div :id="types.schools" :class="{ 'hidden' : predictions !== '' || schools === '' }" class="overflow-y-scroll">
                            <div v-for="(school, key) in schools" :key="key" class="my-4">
                                <button v-if="key < 3" class="grid text-left school w-11/12 mr-auto ml-5 py-1 rounded-2xl" @click="setSchool(school)">
                                    <span class="ml-3 font-bold text-sm"> {{ trans[lang].autoescuela }}  {{ school.title }}</span>
                                    <span class="ml-3 text-xs">{{ school.address }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="hidden md:col-span-1 md:block">
                        <div class="w-full">
                            <img class="w-2/3 p-4 h-full mx-auto rounded-xl" :src="'/img/grey-inactive-map-' + this.type + '.svg'" alt="map" />
                        </div>
                    </div>
                    <div class="block md:col-span-1 md:hidden" :class="{ 'hidden' : inputValue !== '' || predictions !== '' || schools !== '' }">
                        <div :id="types.mapMobile" class="w-full">
                            <img class="w-full py-4 m-0 object-cover h-64 rounded-xl" :src="'/img/grey-inactive-map-mobile.svg'" alt="map" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { isMobile } from "mobile-device-detect";
import GoogleMapApi from '../../GoogleMapApi';
const trans = {
  ca: {
    title: "Tria la teva autoescola!",
    subtitle: "Afegeix una direcció per a triar l'autoescola més pròxima i veure tota la informació i preus del permís",
    direction: "Direcció",
    posActual: "Utilitza la teva ubicació actual",
    gettingLocation: "Obtenint la teva ubicació",
    near: "Autoescoles més pròximes",
    autoescuela: "Autoescola de",
    placeholder: "Cerca per codi postal, carrer o ciutat"
  },
  es: {
    title: "¡Elige tu autoescuela!",
    subtitle: "Añade una dirección para elegir la autoescuela más cercana y ver toda la información y precios del permiso",
    direction: "Dirección",
    posActual: "Utiliza tu ubicación actual",
    gettingLocation: "Obteniendo tu ubicación",
    near: "Autoescuelas más cercanas",
    autoescuela: "Autoescuela de",
    placeholder: "Busca por código postal, calle o ciudad"
  }
};
export default {
    props: ['pallars_school', 'type','mapkey'],
    data() {
        return {
            mobileDevice: isMobile,
            lang: "",
            predictions: "",
            location: "",
            schools: "",
            school: "",
            inputValue: "",
            googleMapApi: "",
            defLocation: "41.3825,2.176944",
            loading: false,
            trans
        };
    },
    methods: {
        onLoad() {
            // if(this.type === 'modal') document.getElementById('app').classList.add('fixed');
            // document.getElementsByTagName('footer')[0].classList.add('fixed');
            // Cargar el mapa interactivo
        },
        // Autocomplete Street Name, show predictions like input
        async autocompleteStreet() {
           this.predictions = await this.googleMapApi.getPredictions(this.inputValue)
        },
        // Autocomplete Input, put street name on input
        async autocompleteInput(placeId) {
            this.clearPredictions()
            this.clearSchools()

            this.location = await this.googleMapApi.getLocation(placeId)
            this.setCookie("location", this.location)
            this.getSchools(this.location)
        },
        // Get location from ur position
        getCurrentLocation() {
            this.loading = true

            const options = {
                enableHighAccuracy: true,
                timeout: 5000, // 5s
                maximumAge: 0
            };

            const vm = this;

            async function success(pos) {
                const location = pos.coords.latitude + "," + pos.coords.longitude
                // Save location on cookies
                vm.setCookie("location", location);

                vm.inputValue = await vm.googleMapApi.getAddress(location)
                vm.location = {lat: pos.coords.latitude, lng: pos.coords.longitude}
                vm.loading = false
            }

            function error(err) {
                console.warn("ERROR(" + err.code + "): " + err.message);
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        },
        async getSchools(currentLocation) {
            axios
                .post("/api/searchSchoolByStreet/search", {
                    target: JSON.stringify(currentLocation)
                })
                .then(response => {
                    // Revisar paquete y hacer reversa futuro (JOEL)
                    document.getElementById(this.type + '-schools').classList.add('h-64');
                    if(window.innerWidth < 768){
                        let map = document.getElementsByClassName('map');
                        for(let i = 0; i < map.length; i++) {
                            map[i].classList.add('hidden');
                        }
                    }
                    this.schools = response.data.schoolCards;
                });
        },
        // Save school selected on cookies and hide popup
        setSchool(school) {
            // Save school on cookies
            window.location.href = '/searchSchoolByStreet/setSchool/' + school.id;
            document.getElementsByTagName('footer')[0].classList.remove('fixed');
        },
        clearSchools() {
            return (this.schools = "");
        },
        clearPredictions() {
            return (this.predictions = "");
        },
        clearLocation() {
            return (this.location = "");
        },
        clearInput() {
            this.inputValue = ''

            this.clearSchools()
            this.clearPredictions()
            this.clearLocation()
        },
        getCookie(key) {
            const name = "pallars_" + key + "=";
            const cookies = document.cookie.split("; ");
            let res;
            cookies.forEach(val => {
                if (val.indexOf(name) === 0) res = val.substring(name.length);
            });
            return res;
        },
        setCookie(key, value) {
            let date = new Date();
            date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();
            (key === 'school') ? value = [value] : value;
            document.cookie = "pallars_" + key + "=" + value + "; " + expires + "; path=/";
        },
        checkCookies() {
            if (this.getCookie("location")) this.location = this.getCookie("location");
        },
        closePopup() {
            // Close popup
            document.getElementById('app').classList.remove('fixed')
            document.getElementById(this.type + '-select-school').classList.toggle('hidden');

            document.getElementsByTagName('footer')[0].classList.remove('fixed');

        }
    },
    computed: {
        types(){
            let type = (this.type === 'modal') ? 0 : 1;
            const types = [
               {
                    'selectSchool' : 'modal-select-school',
                    'streetSearch' : 'modal-street-search',
                    'streetAutocomplete' : 'modal-street-autocomplete',
                    'schools' : 'modal-schools',
                    'mapMobile' : 'modal-map-mobile',
                },
                {
                    'selectSchool' : 'embedded-select-school',
                    'streetSearch' : 'embedded-street-search',
                    'streetAutocomplete' : 'embedded-street-autocomplete',
                    'schools' : 'embedded-schools',
                    'mapMobile' : 'embedded-map-mobile',
                }
            ];

            return types[type];
        }
    },
    created() {
        this.lang = window.appLocale;
        this.googleMapApi = new GoogleMapApi(this.mapkey, this.defLocation)
    },
    mounted() {
        this.onLoad();
    },
    updated() {
        if (this.location && this.schools === "") {
            this.getSchools(this.location);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.modal-container {
    @media (max-width: 767px) and (orientation: landscape) {
        position: absolute;
        height: 35rem;
    }

    .modal {
        @media (min-width: 767px) and (max-width: 1200px){
            top: 8rem;
        }

        @media (max-width: 767px) {
            width: 90%;
            height: 82.5vh;
            max-height: 100%;
            top: 0rem;
            border-radius: 16px;
        }

        .text-grey {
            color: $text-grey;
        }

        .text-watermelon {
            color: $watermelon;
        }

        .close {
            background-color: $bg-close-btn;
        }

        .street-search {
            button {
                top: 10%;
                left: 0%;
            }

            input{
                &::placeholder{
                    color: $black;
                }

                &:focus::placeholder{
                    color: $body-text-grey;
                }
                
                &:focus-visible{
                    outline: none;
                }
            }
        }

        .street-autocomplete {
            top: 0.5rem;
            left: 1rem;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            width: 120%;

            @media (max-width: 820px) {
                left: 0;
                top: -3.5rem;
            }

            @media (max-width: 767px) {
                width: 90%;
                left: 0;
                top: 0.5rem;
            }
        }

        #schools,
        #street-autocomplete {
            button:hover {
                background-color: $bg-hover-button;
            }
        }
    }
}

.close-mobile {
    right: 2rem;
}

.school {
    -webkit-animation: show 1s;
    animation: show 1s;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
}

@keyframes show {
    0% {
        transform: translateY(1200px);
        opacity: 0.7;
    }

    80% {
        transform: translateY(0px);
        opacity: 0.7;
    }

    100% {
        opacity: 1;
    }
}
</style>